const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

const getValue = (record, key) =>
  typeof key === 'function'
    ? key(record)
    : String(key)
        .split('.')
        .reduce((acc, part) => (acc == null ? acc : acc[part]), record);

const toTime = (value) => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

export const sortByString = (key) => (a, b) =>
  collator.compare(String(getValue(a, key) ?? ''), String(getValue(b, key) ?? ''));

export const sortByNumber = (key) => (a, b) =>
  (Number(getValue(a, key)) || 0) - (Number(getValue(b, key)) || 0);

export const sortByDate = (key) => (a, b) => toTime(getValue(a, key)) - toTime(getValue(b, key));

export const fullNameOf = (record) =>
  `${record?.firstname ?? ''} ${record?.lastname ?? ''}`.trim();

export const phoneOf = (record) => `${record?.country_code ?? ''}${record?.phone ?? ''}`;
